import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response, Customer } from '../types'

export interface FetchCustomersResponse extends Response {
  data: Customer[]
}

export interface DeleteCustomerAPIResponse extends Response {
  data: null
}

export type AddCustomerRequest = {
  id?: number
  name: string
  mobile: string
  address: string
  address2?: string
  gstin?: string
  stateCode?: string
  state?: string
  pan?: string
  registrationType?: string
  pincode?: string
  place?: string
}

export interface AddCustomersResponse extends Response {
  data: Customer
}

export const addCustomer = (request: AddCustomerRequest) => {
  return http
    .post<AddCustomerRequest>('/customer/pvt', request)
    .then((response: AxiosResponse) => response)
}
export function fetchCustomers() {
  return http.get('/customer/pvt').then((response: AxiosResponse) => response)
}

export function fetchCustomersV2() {
  return http.get('/customer/pvt/v2').then((response: AxiosResponse) => response)
}

/** Slim party list for autocomplete: id, name, address only. */
export type CustomerV3 = {
  id: number
  name: string
  address?: string
}

export function fetchCustomersV3() {
  return http.get('/customer/pvt/v3').then((response: AxiosResponse) => response)
}

export const fetchCustomerById = (id: number) => {
  return http
    .get(`/customer/pvt/${id}`)
    .then((response: AxiosResponse) => response)
}

export const deleteCustomer = (id: number) => {
  return http
    .delete(`/customer/pvt/${id}`)
    .then((response: AxiosResponse) => response)
}
